// Custom Error Types

import { AxiosError } from "axios";

export class MaxRetriesError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "MaxRetriesError";
  }
}

export const formatCreateQrCodeError = (error: unknown): string | undefined => {
  if (error instanceof AxiosError) {
    return error.response?.data.destination_url || error.response?.data.error;
  }

  return undefined;
};
